/*
    权限操作
*/

import store from '@/store/index.js'
import dynamicRoutes from '@/router/dynamicRoute'

/**
 * 检查当前路由的按钮权限
 * @param code
 */
function buttonPerCheck(code, routePath, thisObj) {
  thisObj = thisObj || this
  const permissionList = store.getters.PermissionList // 权限列表
  let isPermission = false // 是否有权限
  if (
    permissionList === undefined ||
    permissionList === null ||
    permissionList.length === 0
  ) {
    return isPermission
  }
  let routeCur = thisObj.$route // 当前路由
  let routeNameParent = routeCur.meta.routeNameParent // 当前父路由名称
  let url = routeCur.path // 路由路径
  if(routePath){
    routeNameParent = null
    url = routePath
  }
  if (routeNameParent) {
    // 如果存在父路由名称，则通过父路由名称寻找父路由
    const routeParent = getRouteParentByName(dynamicRoutes, routeNameParent)
    if (routeParent !== undefined && routeParent !== null) {
      url = routeParent.path
    }
  }
  if (url.lastIndexOf('/') === url.length - 1) {
    url = url.substr(0, url.length - 1)
  }
  for (let i = 0; i < permissionList.length; i++) {
    const perItem = permissionList[i]
    if (url === perItem.url) {
      // 匹配到路由
      const perButtons = perItem.buttons // 按钮权限集合
      if (
        perButtons !== undefined &&
        perButtons !== null &&
        perButtons.length > 0
      ) {
        for (let m = 0; m < perButtons.length; m++) {
          if (code === perButtons[m].code) {
            isPermission = true // 当前按钮有权限
            break
          }
        }
      }
      break
    }
  }

  return isPermission
}

/**
 * 根据父路由名称寻找父路由
 * @param routeList
 * @param routeNameParent
 * @param isRootRouteWhenOnlyOneL
 * @param routeCurParent
 */
function getRouteParentByName(routeList, routeNameParent, isRootRouteWhenOnlyOneL, routeCurParent) {
  let routeParent = null
  isRootRouteWhenOnlyOneL = (isRootRouteWhenOnlyOneL === true) // 当只有一级导航时是否查找根路由
  if (
    routeList === undefined ||
    routeList === null ||
    routeList.length === 0 ||
    routeNameParent === undefined ||
    routeNameParent === null
  ) {
    return routeParent
  }
  for (let i = 0; i < routeList.length; i++) {
    const route = routeList[i] // 路由
    if (routeNameParent === route.name) {
      // 路由名称匹配
      if (isRootRouteWhenOnlyOneL && route.meta.isOnlyOneLevel === true) {
        // 当只有一级导航时是否查找根路由
        if (routeCurParent !== undefined && routeCurParent !== null) {
          routeParent = routeCurParent
        } else {
          routeParent = getRouteParentOnlyOneByName(routeNameParent)
        }
        break
      } else {
        routeParent = route
        break
      }
    }
    const children = route.children
    if (children !== undefined && children !== null && children.length > 0) {
      routeParent = getRouteParentByName(children, routeNameParent, isRootRouteWhenOnlyOneL, route)
      if (routeParent !== null) {
        break
      }
    }
  }

  return routeParent
}

/**
 * 根据路由名称寻找一级导航父路由
 * @param routeName
 */
function getRouteParentOnlyOneByName(routeName) {
  let routeParent = null
  const routeList = dynamicRoutes
  if (
    routeName === undefined ||
    routeName === null ||
    routeName === ''
  ) {
    return routeParent
  }
  for (let i = 0; i < routeList.length; i++) {
    const route = routeList[i] // 路由
    const children = route.children
    if (children !== undefined && children !== null && children.length > 0) {
      for (let m = 0; m < children.length; m++) {
        const childRoute = children[m]
        if (routeName === childRoute.name) {
          // 路由名称匹配
          routeParent = childRoute
          break
        }
      }
    } else {
      continue
    }
  }

  return routeParent
}

/**
 * 更新当前缓存的用户信息中的默认角色id
 * @param roleId
 */
function updateUserRoleId(roleId) {
  // const data = JSON.parse(localStorage.getItem('userData'))
  const data =  (store.state.user) ? store.state.user.userinfo : undefined 
  if(data){
    data.roleId = roleId
    // localStorage.setItem('userData', JSON.stringify(data))
    store.commit('setUserInfo', data)
  }
}

/**
 * 清空权限列表
 */
function clearPermissionList() {
  // store.getters.PermissionList = []
  store.commit("setPermissionList", [])
  store.commit('setMenuList', [])
}

export default {
  buttonPerCheck,
  getRouteParentByName,
  updateUserRoleId,
  clearPermissionList
}
